import styled from "styled-components";

const PropertiesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin-top: 10px;
`;

export default PropertiesWrapper;